import AuthService from './services/AuthService'

const host = process.env.VUE_APP_BACKEND;

/**
 * Configuration of the authentication service
 */

// Allowed urls to access the application (if your website is http://mywebsite.com, you have to add it)
AuthService.allowedOrigins = [host];

// // Allowed providers to log in our application, and the corresponding server-side endpoints
// AuthService.providers = {
//   'IdentityServer': {
//     //endpoint: host + '/Account/Login'
//     endpoint: host + '/connect/token'
//   },
//   'ADFS': {
//     endpoint: host + '/Account/ExternalLogin?provider=ADFS'
//   },
// };

AuthService.appRedirect = () => router.replace('/');
